// @flow
import _ from 'lodash';
import type { Dispatch } from 'redux';
import { connect } from 'react-redux';
import type { State, Actions } from '../store';
import Products from '../components/Products';
import {
  selectors as permissionSelectors,
  actions as permissionActions
} from '../store/permissions';
import {
  selectors as partnerSelectors,
  actions as partnerActions
} from '../store/partners';

const mapStateToProps = ({ permissionReducer, partnerReducer, authReducer, appReducer }: State) => {
  const products = permissionSelectors.selectUsersProducts(permissionReducer) || [];
  const externals = permissionSelectors.selectUsersExternals(permissionReducer) || [];
  const marketing = permissionSelectors.selectGMParent(permissionReducer) || {};
  const productIds = [...products.map((product) => product.id), marketing.id];
  const permissions = permissionSelectors.selectUsersCurrentPermissions(permissionReducer) || [];

  return {
    error: permissionReducer.error || partnerReducer.error || false,
    products,
    externals,
    marketing,
    acsSession: authReducer.acsSession,
    arePermissionsFetching: permissionReducer.isFetching || false,
    arePartnersFetching: partnerSelectors.isFetching || false,
    productIds,
    globalUserPermissions: permissionSelectors.selectUserPermissionByPermissionIds(permissionReducer, productIds),
    partners: partnerSelectors.selectPartners(partnerReducer),
    brand: appReducer.brand,
  
    globalStatus: _([...products, marketing.id ? marketing : false])
      .compact()
      .flatMap((p) => Object.values(p.allowed))
      .some((x) => x),

    allAllowed: permissions.flatMap((p) => Object.values(p.allowed)).every((v) => v === true)
  };
};
const mapDispatchToProps = (dispatch: Dispatch<Actions>) => ({
  fetchProducts: () => dispatch(permissionActions.fetchPermissions()),
  fetchPartners: () => dispatch(partnerActions.fetchPartners()),
  setGlobal: (globalUserPermissions, value) =>
    dispatch(permissionActions.setGlobal(globalUserPermissions, value)).then(() =>
      dispatch(permissionActions.fetchPermissions())
    )
});
const ProductContainer = connect(mapStateToProps, mapDispatchToProps)(Products);

export default ProductContainer;
